<template>
  <div style="padding: 10px">
    <el-form ref="form" :model="form" label-width="100px" size="small">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>菜单信息</span>
        </div>
        
        <el-form-item label="菜单名称">
          <el-input v-model="form.displayName" placeholder="请输入菜单名称"></el-input>
        </el-form-item>
        
        <el-form-item label="菜单编码">
          <el-input v-model="form.menuCode" placeholder="请输入菜单编码"></el-input>
        </el-form-item>
        
        <el-form-item label="菜单URL">
          <el-input v-model="form.menuUrl" placeholder="请输入菜单URL"></el-input>
        </el-form-item>
        
        <el-form-item label="菜单图标">
          <el-input v-model="form.menuIcon" placeholder="请输入图标类名">
            <template slot="prepend">
              <i :class="form.menuIcon || 'el-icon-menu'"></i>
            </template>
          </el-input>
        </el-form-item>
      </el-card>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      form: {
        displayName: '',
        menuCode: '',
        menuUrl: '',
        menuIcon: 'el-icon-menu'
      }
    }
  },
  watch: {
    value: {
      handler(n) {
        if (n) {
          this.form = {
            displayName: n.displayName || '',
            menuCode: n.menuCode || '',
            menuUrl: n.menuUrl || '',
            menuIcon: n.menuIcon || 'el-icon-menu'
          }
        }
      },
      immediate: true,
      deep: true
    },
    form: {
      handler(n) {
        this.$emit('input', n)
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.box-card {
  border-radius: 8px;
  margin-bottom: 20px;
}

.clearfix {
  font-size: 16px;
  font-weight: bold;
}
</style>
